import React, { Component } from "react";
import { Link } from "react-router-dom";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {  Grid, Button,  Radio,
  RadioGroup } from "@material-ui/core";
import "./login.css";
import { API_URL } from "../Config";
import Image from "../assets/images/loginOtp.svg";
import SnackBarComponent from "../SnackBar/SnackBar";
class SendOTP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: !this.props.location.state
        ? ""
        : !this.props.location.state.username
        ? ""
        : this.props.location.state.username,
      refreshOtpToken: !this.props.location.state
        ? ""
        : !this.props.location.state.refreshOtpToken
        ? ""
        : this.props.location.state.refreshOtpToken,
      email: true,
      sms: false,
      error: { check: "" },
      open: false,
      severity: "",
      alertmsg: "",
      disabled: false,
      options:[{name:"Email",value:"Email"},{name:"SMS",value:"SMS"}]
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    }
  }
  handleCheckbox = (e) => {
    const {
      target: { name, checked },
    } = e;
    if (checked === true) {
      let { error } = this.state;
      delete error["check"];
      this.setState({ error });
    }
    if (name === "Email") {
      this.setState({ email: checked, sms: checked ? !checked : checked });
    } else {
      this.setState({ sms: checked, email: checked ? !checked : checked });
    }
  };
  Validation = () => {
    let error = {};
    let { email, sms } = this.state;
    if (email === false && sms === false) {
      error["check"] = "Please select one of them";
    }
    this.setState({ error });
    if (Object.keys(error).length === 0) {
      return true;
    } else {
      return false;
    }
  };

  getOtp = () => {
    let checked = this.Validation();
    if (!checked) {
      return;
    } else {
      this.setState({ disabled: true });
      let codeTo =
        this.state.email && this.state.sms
          ? "both"
          : this.state.sms
          ? "sms"
          : this.state.email
          ? "email"
          : "";
      fetch(
        `${API_URL}/api/Userdata/generateOTP?refreshOtpToken=${localStorage.getItem(
          "refreshtoken"
        )}&verificationCodeTo=${codeTo}`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            // query: Query,
            // variables: Variables,
          }),
          headers: {
            "Content-type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.setState({ disabled: false });
          if (res.data) {
            if (res.data.status === "success") {
              this.props.history.push({
                pathname: "/verifyOtp",
                state: {
                  verificationCodeTo: codeTo,
                  message: res.data.message,
                },
              });
            } else {
              this.setState({
                connectionError: res.data.message,
                severity: "error",
                open: true,
                alertmsg: res.data.message,
                timer: 3000,
              });
            }
          } else {
            this.setState({
              connectionError: res.error.message,
              severity: "error",
              open: true,
              alertmsg: res.error.message,
              timer: 3000,
            });
          }
        })
        .catch((e) => {
          this.setState({
            disabled: false,
            connectionError: e.toString().substring(11, e.length),
            severity: "error",
            open: true,
            alertmsg: e.toString().substring(11, e.length),
            timer: 3000,
          });
        });
    }
  };
  handleClose = () => {
    this.setState((prevState) => {
      return {
        open: !prevState.open,
      };
    });
  };
  BacktoLogin = () => {
    localStorage.clear();
  };
  render() {
    const options = this.state.options.map((item, i) => {
      return (
        <FormControlLabel
          key={i}
          value={item.value}
          control={<Radio />}
          label={item.name}
        />
      );
    });
    return (
      <div className="loginOtpSection">
        <div className="logoimg">
          <img src={Image} alt="RCM Logo"></img>
        </div>
        <h4>LOG IN</h4>
        <p>
          To verify your identity, a one time passcode (OTP) will be sent to you. Please
          choose which method you would prefer to receive your security code.
        </p>
        <Grid className="OtpSection">
          <h5>Send OTP over</h5>
          <ul>
            <li>
                <RadioGroup onChange={this.handleCheckbox} defaultValue="Email" className="radioBox">{options}</RadioGroup>
            </li>
          </ul>
          <span style={{ color: "red" }}>{this.state.error.check}</span>
          {/* {this.state.connectionError ? (
            <div className="connectionOtp">
              <p>{this.state.connectionError}</p>
            </div>
          ) : (
            ""
          )} */}
        </Grid>
        <Button onClick={this.getOtp} disabled={this.state.disabled}>
          Get OTP
        </Button>
        <Grid container className="createAccount">
          <Grid item xs>
            <Link to="/" onClick={this.BacktoLogin}>
              Back To Login Page
            </Link>
          </Grid>
        </Grid>
        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            handleClose={this.handleClose}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default SendOTP;
